module.exports = __webpack_public_path__ + "static/img/leopard2.4d75e96.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/leopard2.jpg
// module id = Y6el
// module chunks = 1